@if (isFemaleCondom) {
  <app-order-complete-instructions-female-condom />
} @else {
  @switch (site) {
    @case (Sites.Stdcheck) {
      <app-order-complete-instructions-stdcheck [orderCompleteDetails]="orderCompleteDetails" />
    }
    @case (Sites.Healthlabs) {
      <app-order-complete-instructions-healthlabs [orderCompleteDetails]="orderCompleteDetails" />
    }
    @case (Sites.AnalyteHealth) {
      <app-order-complete-instructions-healthlabs [orderCompleteDetails]="orderCompleteDetails" />
      @if (showPatientIntakeSection) {
        <app-order-complete-intake-link class="is-block mt-4" [intakeUrl]="intakeUrl"></app-order-complete-intake-link>
      }
    }
    @case (Sites.Treatmyuti) {
      <app-order-complete-instructions-treatmyuti
        [orderCompleteDetails]="orderCompleteDetails"
        [treatmentType]="treatmentType"
      />
    }
    @case (Sites.Starfish) {
      <app-order-complete-instructions-starfish
        [orderCompleteDetails]="orderCompleteDetails"
        [treatmentType]="treatmentType"
      />
    }
    @case (Sites.Stallion) {
      <app-order-complete-instructions-stallion
        [orderCompleteDetails]="orderCompleteDetails"
        [treatmentType]="treatmentType"
      />
    }
    @case (Sites.TestosteroneHq) {
      <app-order-complete-instructions-testosterone-hq
        [orderCompleteDetails]="orderCompleteDetails"
        [treatmentType]="treatmentType"
      />
    }
  }
}
